// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".switcher[data-v-5f056c6e]{border:none;margin:0;padding:0}", "",{"version":3,"sources":["webpack://./src/js/vue/add-to-cart/components/form-fields/Switcher.vue"],"names":[],"mappings":"AACA,2BACI,WAAA,CACA,QAAA,CACA,SAAJ","sourcesContent":["\n.switcher {\n    border: none;\n    margin: 0;\n    padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
